import { render, staticRenderFns } from "./WealthEnhancer.vue?vue&type=template&id=057a25f5&scoped=true&"
import script from "./WealthEnhancer.vue?vue&type=script&lang=js&"
export * from "./WealthEnhancer.vue?vue&type=script&lang=js&"
import style0 from "./WealthEnhancer.vue?vue&type=style&index=0&id=057a25f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057a25f5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCol,VRow,VTextField})
